import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { stickyHeaderCellSx } from '../../styles/sxStyling';

interface StickyTableHeaderProps {
  cells: React.ReactNode[];
}

export default function StickyTableHeader({ cells }: StickyTableHeaderProps) {
  return (
    <TableHead>
      <TableRow>
        {cells.map((cell, index) => (
          <TableCell key={index} sx={stickyHeaderCellSx}>
            {cell}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
